import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Events from "./pages/Events";
import Archive from "./pages/Archive";
import Membership from "./pages/Membership";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen bg-white">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="about" element={<About />} />
              <Route path="events" element={<Events />} />
              <Route path="archive" element={<Archive />} />
              <Route path="membership" element={<Membership />} />
              <Route path="contact" element={<Contact />} />
            </Route>
            <Route path="/admin-portal" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </LanguageProvider>
  );
}

export default App;
